import { useSelector } from 'react-redux';
import { permissionObj } from './../../../../../Helpers/permission';
import ShiftManagementModal from '../Modal/ShiftManagementModal';
import DeleteModal from '../../../../Modals/DeleteModal';
import ButtonSubAction from './../../../../../components/buttons/ButtonSubAction';
import { AddIcon, TrashOutlineIcon } from '../../../../../components/buttons/IconButtons';
import AssignedEmployeesApp from '../Functionality/AssignedEmployeesApp';
import Subtitle from '../../../../../components/Header/Subtitle';
import ButtonAction from './../../../../../components/buttons/ButtonAction';
import CustomTable from '../../../../../components/table/CustomTable';
import { toast } from 'react-toastify';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @returns {JSX.Element}
 * @constructor
 */
const AssignedEmployees = ({ id }) => {
    const {
        selectedList,
        setSelectedList,
        deleteManageUser,
        setDeleteManageUser,
        addUserModal,
        setAddUserModal,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedManageUser,
        pagination,
        thead,
        tbody,
        tableId,
        setModified,
        modified,
        isAllChecked,
        setIsAllChecked,
        WorkTimeAccess,
        t
    } = AssignedEmployeesApp({ id });

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    return (
        <>
            <div className='mt-4'>
                <Subtitle
                    name={'assgined_employees'}
                    divStack={
                        <>
                            {(DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_MANAGE_USERS)) && (
                                <ButtonSubAction
                                    id='btn_ae_manage_users'
                                    name='manage_users'
                                    Icon={AddIcon}
                                    onClick={() => {
                                        if (!WorkTimeAccess || WorkTimeAccess.content.length === 0) {
                                            toast.warn(t('you_must_add_schedule_first'));
                                            return;
                                        }
                                        setAddUserModal(true);
                                    }}
                                />
                            )}
                        </>
                    }
                >
                    {selectedList?.length > 0 &&
                        (DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_MANAGE_USERS)) && (
                            <ButtonAction
                                id='btn_ae_delete'
                                name='delete'
                                className='btn-icon-delete'
                                Icon={TrashOutlineIcon}
                                onClick={() => setDeleteManageUser(true)}
                                splitName={false}
                            />
                        )}
                </Subtitle>
            </div>

            <CustomTable
                tableId={tableId}
                checkbox={true}
                checkboxTitle={'de_/_select_all'}
                isAllChecked={isAllChecked}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                onChangeCheckbox={handleDeleteAll}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                withoutHeight={true}
            />
            {pagination()}

            { addUserModal &&
                <ShiftManagementModal
                    show={addUserModal}
                    onHide={() => setAddUserModal(false)}
                    selectedId={id}
                    setModified={setModified}
                    modified={modified}
                />
            }

            <DeleteModal
                show={deleteManageUser}
                onHide={() => setDeleteManageUser(false)}
                onClickFn={() => deleteSelectedManageUser(selectedList)}
                data={selectedList}
                description={'are_you_sure_you_want_to_remove'}
                title_modal={'workshift'}
                element_modal={'workshift'}
                isReset={setSelectedList}
            />
        </>
    );
};

export default AssignedEmployees;
